// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__4N59F","content":"Auth_content__o5JcK","wrapper":"Auth_wrapper__Si5Oi"};